class ProfessionalAccountAccess extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-professional-account-toggle]');
    this.panel = this.querySelector('[data-professional-account-panel]');

    if (!(this.toggle instanceof HTMLButtonElement) || !(this.panel instanceof HTMLElement)) return;

    this.toggle.addEventListener('click', this.handleToggle);
    this.querySelectorAll('[data-professional-account-close]').forEach((button) => {
      button.addEventListener('click', this.close);
    });
    this.querySelectorAll('[data-professional-account-action]').forEach((action) => {
      action.addEventListener('click', this.closeWithoutFocus);
    });
    document.addEventListener('click', this.handleOutsideClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsideClick);
    document.removeEventListener('keydown', this.handleKeydown);
  }

  handleToggle = () => {
    if (this.panel?.hidden) {
      this.open();
    } else {
      this.close();
    }
  };

  open = () => {
    if (!(this.panel instanceof HTMLElement) || !(this.toggle instanceof HTMLButtonElement)) return;

    this.panel.hidden = false;
    this.toggle.setAttribute('aria-expanded', 'true');
    this.querySelector('[data-professional-account-close]')?.focus();
  };

  close = () => {
    this.closeWithoutFocus();
    this.toggle?.focus();
  };

  closeWithoutFocus = () => {
    if (!(this.panel instanceof HTMLElement) || !(this.toggle instanceof HTMLButtonElement)) return;

    this.panel.hidden = true;
    this.toggle.setAttribute('aria-expanded', 'false');
  };

  handleOutsideClick = (event) => {
    if (!(event.target instanceof Node) || this.contains(event.target)) return;

    this.closeWithoutFocus();
  };

  handleKeydown = (event) => {
    if (event.key !== 'Escape' || this.panel?.hidden) return;

    event.preventDefault();
    this.close();
  };
}

if (!customElements.get('professional-account-access')) {
  customElements.define('professional-account-access', ProfessionalAccountAccess);
}
